import { render, staticRenderFns } from "./hue-picker-field.vue?vue&type=template&id=53b1606d&scoped=true"
import script from "./hue-picker-field.vue?vue&type=script&lang=js"
export * from "./hue-picker-field.vue?vue&type=script&lang=js"
import style0 from "./hue-picker-field.vue?vue&type=style&index=0&id=53b1606d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b1606d",
  null
  
)

export default component.exports